module.exports = __webpack_public_path__ + "img/marketing-target.ddeb2d6b.svg";